module.exports = __webpack_public_path__ + "img/CM-KT-25-Chevy-Modern.065c1531.jpg";